<template>
  <div class="sticker-mgmt">
    <div class="sticker-tabs">
      <div
        v-for="tab in tabs"
        :key="tab.name"
        class="sticker-tab-item"
        :class="{ 'sticker-tab-active': tab.name === currentTab }"
        @click="currentTab = tab.name"
      >
        <p>{{ tab.label }}</p>
      </div>
    </div>
    <div class="sticker-content">
      <component :is="currentComponent"></component>
    </div>
  </div>
</template>

<script>
import StickerLibrary from "./stickerLibrary/index.vue";
import StickerCategories from "./stickerCategories/index.vue";

export default {
  name: "StickerMgmt",
  components: {
    StickerLibrary,
    StickerCategories
  },
  data() {
    return {
      currentTab: "StickerLibrary",
      tabs: [
        {
          name: "StickerLibrary",
          label: "贴纸库管理",
          component: StickerLibrary
        },
        {
          name: "StickerCategories",
          label: "贴纸库分类管理",
          component: StickerCategories
        }
      ]
    };
  },
  computed: {
    currentComponent() {
      const tab = this.tabs.find(tab => tab.name === this.currentTab);
      return tab ? tab.component : null;
    }
  }
};
</script>

<style scoped>
.sticker-mgmt {
  background: #ffffff;
  width: 100%;
  height: 100%;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.sticker-tabs {
  display: flex;
  flex-shrink: 0;
  padding: 16px;
  border: 0;
  border-bottom: 1px solid #e5e7eb;
  gap: 20px;
}

.sticker-tab-item {
  cursor: pointer;
  font-size: 14px;
  color: #606266;
}

.sticker-tab-item:hover {
  color: #409eff;
}

.sticker-tab-active {
  color: #409eff;
  font-weight: 500;
}

.sticker-content {
  flex: 1;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
}
</style>
